module.exports = __webpack_public_path__ + "static/media/geometrical.1de55e06.png";